var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhilips = function SvgPhilips(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2759",
    xmlns: "http://www.w3.org/2000/svg",
    height: 91.636,
    width: 499.76,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2761"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2855"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2857",
    d: "m0 595.28h841.89v-595.28h-841.89v595.28z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-127.26 -383.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2851",
    transform: "matrix(1.25 0 0 -1.25 -154.36 849.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2853",
    clipPath: "url(#clipPath2855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2859",
    d: "m360.92 371.16h-21.48v-27.97h-22.36v27.97h-21.48v-70.37h21.48v27.68h22.36v-27.68h21.48v70.37zm74.72-56.23v56.23h-21.48v-70.37h38.84l3.23 14.14h-20.59zm-37.36 56.23h-21.48v-70.37h21.48v70.37zm87.08 0h-21.47v-70.37h21.47v70.37zm105.9-17.96c0 3.83 3.83 5.6 10 5.6 6.77 0 14.13-1.48 19.13-3.55l-1.76 15.32c-5.6 1.18-10.6 2.06-19.71 2.06-17.36 0-29.13-6.85-29.13-21.2 0-24.73 33.55-19.73 33.55-31.21 0-4.41-3.25-6.76-11.19-6.76-7.05 0-17.95 2.35-24.42 5.59l2.36-16.2c6.47-2.36 15.29-3.53 22.36-3.53 17.94 0 32.65 5.89 32.65 23.56 0 23.54-33.84 19.13-33.84 30.32m-60.59-35.63c19.99 0 32.65 10.31 32.65 28.27 0 19.72-13.53 26.79-35.6 26.79-8.53 0-18.83-0.59-26.18-1.47v-70.37h21.48v16.78h7.65zm11.47 27.97c0-9.12-4.41-15.31-15.6-15.31h-3.52v29.08c1.25 0.07 2.42 0.07 3.52 0.07 10.59 0 15.6-5 15.6-13.84m-287.72-27.97c20 0 32.65 10.31 32.65 28.27 0 19.72-13.53 26.79-35.59 26.79-8.54 0-18.83-0.59-26.19-1.47v-70.37h21.48v16.78h7.65zm11.48 27.97c0-9.12-4.42-15.31-15.6-15.31h-3.53v29.08c1.25 0.07 2.43 0.07 3.53 0.07 10.59 0 15.6-5 15.6-13.84",
    fill: "#0B5ED7"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhilips);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "philips.3a04624552128466e3f834b06e92d8ac.svg";